// extracted by mini-css-extract-plugin
export default {"cards":"AdminDashboardPage_cards__yRSOu","card":"AdminDashboardPage_card__ZYz+o"};